var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chart',{ref:"chartInstance",staticClass:"chart",attrs:{"option":_vm.chartOption,"autoresize":true,"theme":"custom-theme"}})}
var staticRenderFns = []

export { render, staticRenderFns }